import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Calendar, ListOrdered, User } from 'lucide-react';

const TABS = [
  { key: 'home', label: 'Home', icon: Calendar, path: '/home', testId: 'nav-home-button' },
  { key: 'bookings', label: 'Bookings', icon: ListOrdered, path: '/bookings', testId: 'nav-bookings-button' },
  { key: 'profile', label: 'Profile', icon: User, path: '/profile', testId: 'nav-profile-button' },
];

// A booking-details page (/booking/:id) is reached from the Bookings list,
// so it keeps the Bookings tab highlighted rather than showing no active tab.
const isTabActive = (tabPath, pathname) => {
  if (tabPath === '/bookings') return pathname === '/bookings' || pathname.startsWith('/booking/');
  return pathname === tabPath;
};

/**
 * Shared bottom tab bar for authenticated customer "hub" pages
 * (Home, Bookings, Booking Details, Profile). Mounted once by
 * CustomerNavLayout so every page under it gets identical, always-visible
 * navigation with a correctly highlighted active tab.
 */
export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="bottom-nav" data-testid="bottom-nav">
      <div className="max-w-md mx-auto flex justify-around items-center py-2 px-6">
        {TABS.map(({ key, label, icon: Icon, path, testId }) => {
          const active = isTabActive(path, location.pathname);
          return (
            <button
              key={key}
              onClick={() => navigate(path)}
              data-testid={testId}
              data-active={active ? 'true' : 'false'}
              className="flex flex-col items-center justify-center gap-1 min-h-[48px] min-w-[64px] transition-colors"
              style={{ color: active ? '#0057A8' : undefined }}
            >
              <Icon className={`w-6 h-6 ${active ? '' : 'text-muted-foreground'}`} />
              <span className={`text-xs font-bold uppercase ${active ? '' : 'text-muted-foreground'}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
